// extracted by mini-css-extract-plugin
export default {"charts":"Chart_charts__9ADB9","card":"Chart_card__Xe10q"};